import React from 'react';
import CustomDropdown from '../shared/CustomDropdown';

/**
 * Status Code Filter Component
 * Allows filtering by status code categories or individual codes
 * All options available directly in dropdown - no modal needed
 */
const StatusCodeFilter = ({ value, onChange }) => {
  
  const handleFilterChange = (newValue) => {
    // Check if it's a specific code (number string) or a category
    if (newValue.match(/^\d+$/)) {
      // Individual status code selected
      const code = parseInt(newValue, 10);
      onChange('custom', [code]);
    } else {
      // Category selected (all, 2xx, 4xx, 5xx)
      onChange(newValue, []);
    }
  };

  // Build dropdown options with all status codes
  const dropdownOptions = [
    { value: 'all', label: 'All Status Codes' },
    { divider: true },
    { value: '2xx', label: 'Success (2xx)', icon: '✅' },
    { value: '4xx', label: 'Client Errors (4xx)', icon: '🔴' },
    { value: '5xx', label: 'Server Errors (5xx)', icon: '🔴' },
    { divider: true },
    // Individual status codes
    { value: '200', label: '200 OK', icon: '✅' },
    { value: '401', label: '401 Unauthorized', icon: '🔴' },
    { value: '429', label: '429 Too Many Requests', icon: '🔴' },
    { value: '500', label: '500 Internal Server Error', icon: '🔴' },
    { value: '502', label: '502 Bad Gateway', icon: '🔴' },
    { value: '503', label: '503 Service Unavailable', icon: '🔴' },
    { value: '504', label: '504 Gateway Timeout', icon: '🔴' }
  ];

  // Determine current selected value for dropdown
  const getCurrentValue = () => {
    if (value.type === 'custom' && value.codes.length === 1) {
      // Single code selected - show it as the value
      return String(value.codes[0]);
    }
    return value.type;
  };

  return (
    <div className="relative">
      <CustomDropdown
        label="Status Code"
        options={dropdownOptions}
        value={getCurrentValue()}
        onChange={handleFilterChange}
        placeholder="Select status code"
      />
      
      {/* Show info for multi-select (if implemented later) */}
      {value.type === 'custom' && value.codes.length > 1 && (
        <div className="mt-2 text-xs text-gray-600">
          <span className="inline-flex items-center px-2 py-1 rounded-md bg-blue-100 text-blue-700">
            {value.codes.length} codes selected: {value.codes.join(', ')}
          </span>
        </div>
      )}
    </div>
  );
};

export default StatusCodeFilter;